import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ActionsCollapserContext = /*#__PURE__*/createContext(undefined);
export const ActionsCollapserProvider = ({
  actionsMenuStyleOverrides,
  buttonWrapperStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(ActionsCollapserContext.Provider, {
    value: {
      actionsMenuStyleOverrides,
      buttonWrapperStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `ActionsCollapser` component.
 * Note: The context is only available when the `ActionsCollapser` component is rendered as an ancestor.
 * @returns ActionsCollapserContext - The context for the `ActionsCollapser` component.
 * @returns ActionsCollapserContext.actionsMenuStyleOverrides - Style overrides to be applied to the `ActionsMenu` component.
 * @returns ActionsCollapserContext.buttonWrapperStyleOverrides - Style overrides to be applied to the `ButtonWrapper` component.
 */
export const useActionsCollapserContext = () => {
  return useContext(ActionsCollapserContext);
};